(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
var DATE_FORMAT = 'ddd, MMM D, YYYY';
var TIME_FORMAT = 'HH:mm';

var formatPatientName = function formatPatientName(name) {
  if (!name || !name.length) {
    return '';
  }

  var usualName = name.find(function (n) {
    return n.use === 'usual';
  }) || name[0];
  var text = usualName.text,
      given = usualName.given,
      family = usualName.family,
      prefix = usualName.prefix,
      suffix = usualName.suffix;

  if (text) {
    return text;
  }

  var familyGiven = [];

  if (family) {
    familyGiven.push(family);
  }

  if (given && given.length) {
    familyGiven.push(given.join(' '));
  }

  var fullName = [];

  if (prefix && prefix.length) {
    fullName.push(prefix.join(', '));
  }

  if (familyGiven && familyGiven.length) {
    fullName.push(familyGiven.join(', '));
  }

  if (suffix && suffix.length) {
    fullName.push(suffix.join(', '));
  }

  if (!fullName || !fullName.length) {
    return '';
  }

  return fullName.join(', ');
};

var formatCoding = function formatCoding(coding) {
  if (!coding || !coding.length) {
    return '';
  }

  return t('ehr', coding.display);
};

var formatCodeableConcept = function formatCodeableConcept(codeableConcept) {
  if (!codeableConcept || !codeableConcept.length) {
    return '';
  }

  var coding = codeableConcept[0].coding;
  return formatCoding(coding);
};

var formatDatePeriod = function formatDatePeriod(datePeriod) {
  var _ref = datePeriod || {},
      start = _ref.start,
      end = _ref.end;

  if (!start || !end) {
    return '';
  }

  var startMoment = moment(start).local();
  var endMoment = moment(end).local();

  if (startMoment.isSame(endMoment, 'day')) {
    var day = startMoment.format(DATE_FORMAT);
    var startTime = startMoment.format(TIME_FORMAT);
    var endTime = endMoment.format(TIME_FORMAT);
    return "".concat(day, ", ").concat(startTime, " - ").concat(endTime);
  } else {
    var startDay = startMoment.format(DATE_FORMAT);
    var endDay = endMoment.format(DATE_FORMAT);

    var _startTime = startMoment.format(TIME_FORMAT);

    var _endTime = endMoment.format(TIME_FORMAT);

    return "".concat(startDay, ", ").concat(_startTime, " - ").concat(endDay, ", ").concat(_endTime);
  }
};

var _default = {
  formatPatientName: formatPatientName,
  formatCoding: formatCoding,
  formatCodeableConcept: formatCodeableConcept,
  formatDatePeriod: formatDatePeriod
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DATE_FORMAT, "DATE_FORMAT", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
  reactHotLoader.register(TIME_FORMAT, "TIME_FORMAT", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
  reactHotLoader.register(formatPatientName, "formatPatientName", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
  reactHotLoader.register(formatCoding, "formatCoding", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
  reactHotLoader.register(formatCodeableConcept, "formatCodeableConcept", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
  reactHotLoader.register(formatDatePeriod, "formatDatePeriod", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/fhirDataFormatter.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();